import {useState, useEffect} from 'react'
import {toast} from 'react-toastify'
import {useSelector, useDispatch} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {login, reset} from '../features/auth/authSlice'

function Login() {
    const [formData, setFormData] = useState({
        email: 'dan.c@natiive.com.au',
        password: 'password',
    })

    const {email, password} = formData

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const {user, isLoading, isSuccess, isError, message} = useSelector(state => state.auth)

    useEffect(() => {
        if(isError) {
            toast.error(message)
            dispatch(reset())
        }
        
        if(isSuccess || user) {
            navigate('/overview')
        }

        // dispatch(reset())
    }, [isError, isSuccess, user, message, navigate, dispatch])

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }))
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const userData = {
            email,
            password
        }

        dispatch(login(userData))
    }

    if (isLoading) {
      return <></>
    }

    return (
        <>
            <section className='loginSection'>
                <img src='/logo.png' className='logo' alt='Mention Me' />
                <form onSubmit={onSubmit}>
                    <div className='form-group'>
                        <input type='email' className='form-control' id='email' name='email' value={email} placeholder='Your Email' onChange={onChange} required />
                    </div>
                    <div className='form-group'>
                        <input type='password' className='form-control' id='password' name='password' value={password} placeholder='Your Password' onChange={onChange} required />
                    </div>
                    <div className='form-group'>
                        <button className='btn btn-dark'>Login</button>
                    </div>
                </form>
            </section>
        </>
    )
}

export default Login
